module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "width": "100%"
    }
  }, [_c('v-card-title', [_c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("New Vehicle")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.formTitle))])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "newVehicle",
    model: {
      value: (_vm.newVehicleValid),
      callback: function($$v) {
        _vm.newVehicleValid = $$v
      },
      expression: "newVehicleValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Vehicle Registration",
      "rules": [function (v) { return !!v || 'Vehicle Registration is required'; }],
      "required": "",
      "hint": "Vehicle Regs will automatically be uppercased and spaces removed",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.editedItem.VehicleReg),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "VehicleReg", $$v)
      },
      expression: "editedItem.VehicleReg"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Make",
      "items": _vm.vehicleMakes,
      "item-text": "name",
      "item-value": "key",
      "combobox": "",
      "clearable": ""
    },
    model: {
      value: (_vm.makeSelect),
      callback: function($$v) {
        _vm.makeSelect = $$v
      },
      expression: "makeSelect"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Model",
      "items": _vm.modelList,
      "item-text": "name",
      "item-value": "key",
      "loading": _vm.gettingModels,
      "combobox": "",
      "clearable": ""
    },
    model: {
      value: (_vm.editedItem.Model),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Model", $$v)
      },
      expression: "editedItem.Model"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Year",
      "type": "number"
    },
    model: {
      value: (_vm.editedItem.Year),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Year", $$v)
      },
      expression: "editedItem.Year"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Customer",
      "items": _vm.customerList,
      "rules": [function (v) { return !!v || 'Customer is required'; }],
      "item-text": "name",
      "item-value": "key",
      "required": ""
    },
    model: {
      value: (_vm.editedItem.Customer),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Customer", $$v)
      },
      expression: "editedItem.Customer"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Site",
      "items": _vm.filteredSites,
      "item-text": "name",
      "item-value": "key",
      "rules": [function (v) { return !!v || 'Site is required'; }],
      "required": "",
      "append-outer-icon": "mdi-plus"
    },
    on: {
      "click:append-outer": function($event) {
        _vm.siteDialog = true
      }
    },
    model: {
      value: (_vm.editedItem.Site),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Site", $$v)
      },
      expression: "editedItem.Site"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.siteDialog),
      callback: function($$v) {
        _vm.siteDialog = $$v
      },
      expression: "siteDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.siteDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Sites")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.siteDialog = false
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-layout', [(_vm.siteDialog) ? _c('sites-view') : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": "",
      "disabled": !_vm.newVehicleValid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('multi-vehicle-dialog', {
    attrs: {
      "parentCustomer": null
    },
    on: {
      "vehiclesAdded": _vm.vehiclesAdded
    }
  }), _vm._v(" "), _c('bulk-add-vehicle-dialog', {
    on: {
      "vehiclesAdded": _vm.vehiclesAdded
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("Export")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "clearable": "",
      "label": "Select Customer",
      "items": _vm.customerList,
      "item-text": "name",
      "item-value": "key",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCustomer),
      callback: function($$v) {
        _vm.selectedCustomer = $$v
      },
      expression: "selectedCustomer"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.modifiedVehicles,
      "search": _vm.search,
      "item-key": "id",
      "loading": _vm.tableLoading,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.friendlyId ? props.item.friendlyId : 'TBC'))]), _vm._v(" "), _c('td', {
          style: (props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;')
        }, [_vm._v(_vm._s(_vm._f("uppercase")((props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC'))) + " "), (props.item.VehicleReg && _vm.duplicateRegs.indexOf(props.item.VehicleReg.toLowerCase().replace(/ /g, '')) > -1) ? _c('v-icon', {
          attrs: {
            "color": "red",
            "small": ""
          }
        }, [_vm._v("mdi-numeric-2-box-multiple-outline")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.CustomerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.SiteName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Make))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Year))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.editItem(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteItem(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), [_c('v-textarea', {
    attrs: {
      "hidden": _vm.hideExportBox,
      "id": "excelInput",
      "label": "Excel Data Input"
    },
    model: {
      value: (_vm.excelInput),
      callback: function($$v) {
        _vm.excelInput = $$v
      },
      expression: "excelInput"
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7358c82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Vehicle.vue
// module id = 770
// module chunks = 1